/**
 * O tamanho de destino de uma imagem, mantendo a proporção.
 *
 * **Mora em `shared/` porque tem dois donos**: a foto do cupom
 * (`@ui/notas/prepare-image`) e a foto do produto (`@ui/produtos/prepare-photo`).
 * Enquanto era de um só, viver junto do resto do processamento estava certo;
 * duas cópias da mesma conta seriam duas chances de uma delas ganhar um
 * arredondamento diferente.
 */

/**
 * **Nunca aumenta**: uma foto que já é pequena sai como entrou, porque ampliar
 * não acrescenta informação nenhuma e só produz bytes.
 */
export function fitWithin(
  width: number,
  height: number,
  max: number,
): { width: number; height: number } {
  // Dimensão inválida não vira conta: devolve o que veio, e quem chama desiste.
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return { width, height }
  }
  const maior = Math.max(width, height)
  if (maior <= max) return { width, height }

  const fator = max / maior
  return {
    // `Math.max(1, ...)` porque uma imagem muito estreita arredondaria para
    // zero, e canvas de largura zero lança.
    width: Math.max(1, Math.round(width * fator)),
    height: Math.max(1, Math.round(height * fator)),
  }
}
